<div class="modal-container">
  <div [dir]="biService.getDir() ? 'rtl': 'ltr'" class="d-flex justify-content-between pe-2 ps-2 pt-2">
    <h3 class="modal-title">{{Parentdata.Title | translate}}</h3>
      <button class="btn-x" (click)="CloseDialog()">X</button>
  </div>
  <div class="main">
    <kendo-grid [sort]="Parentdata.DataSource.state.sort" [class.rtl]="biService.getDir()"
      [data]="Parentdata.data$ | async" filterable="menu" [height]="300" [sortable]="true" [resizable]="true"
      (dataStateChange)="FilterChange($event)" [filter]="Kendofilter" (cellClick)="Parentdata.cellClickHandler($event)"
      [selectable]="true" (dblclick)="OK()">
      
      <kendo-grid-column [sortable]="true" [width]="50" class="text-center" *ngIf="Parentdata.hasSelection">
        <ng-template kendoGridHeaderTemplate *ngIf="Parentdata.hasSelection">        
          <input type="checkbox" class="ms-2" [(ngModel)]="SelectAllValue" (change)="ChangeSelectAll($event)">
        </ng-template>

        <ng-template kendoGridCellTemplate let-dataItem>
          <input type="checkbox" [(ngModel)]="dataItem.selected" [checked]="SelectAllValue" (change)="onCheckboxChanged(dataItem)">
        </ng-template>
      </kendo-grid-column>
      <kendo-grid-column *ngFor="let res of Parentdata.DataSource?.Columns" [filter]="res.DataType"
        [filterable]="res.IsFilterable !== false" [sortable]="res.IsFilterable !== false" [field]="res.Name"
        [title]="res.DisplayName? (res.DisplayName | translate) : (res.Name | translate)" [width]="res.Width ? res.Width: 140">
    
        <ng-template kendoGridCellTemplate let-dataItem
          *ngIf="res.controlType==='numeric' || res.controlType==='number'">
          <span
            [ngStyle]="res.ConditionalCellStyleFn ? res.ConditionalCellStyleFn(dataItem) : ''">{{dataItem[res.Name]}}</span>
        </ng-template>


        <ng-template kendoGridCellTemplate let-dataItem *ngIf="res.controlType==='text' || res.controlType==='text'">
          <span
            [ngStyle]="res.ConditionalCellStyleFn ? res.ConditionalCellStyleFn(dataItem) : ''">{{dataItem[res.Name]}}</span>
        </ng-template>

        <ng-template kendoGridCellTemplate let-dataItem *ngIf="res.DataType=='image'">
          <img [src]="'./assets/images/'+dataItem[res.Name]+'.png'" />
        </ng-template>

        <ng-template kendoGridCellTemplate let-dataItem *ngIf="res.DataType=='LogError'">
          <div class="error-log" kendoButton *ngIf="!openedError" (click)="open($event,res,dataItem)">Show Error Log
          </div>
          <kendo-dialog [title]="res.ModalTitle||'Message'" *ngIf="openedError" (close)="close('cancel')"
            [minWidth]="250" [width]="'80%'">
            <p class="msg-dialog">{{DialogText}}</p>
          </kendo-dialog>

        </ng-template>
      </kendo-grid-column>
    </kendo-grid>
    <kendo-datapager [dir]="biService.getDir() ? 'rtl': 'ltr'" class="mb-2 font-weight-bold " [total]="totalDataLength"
      [pageSize]="Parentdata.state.take ? Parentdata.state.take : 0"
      [skip]="Parentdata.state.skip ? Parentdata.state.skip : 0" (pageChange)="onPageChange($event)">
      <kendo-datapager-messages page="{{'page' | translate}}" of="{{'of' | translate}}"
        items="{{'vu_StockCheck' | translate}}"
        itemsPerPage="{{'items Per Page' | translate}}"></kendo-datapager-messages>
    </kendo-datapager>
  </div>
  <div class="justify-content-end mb-2" mat-dialog-actions>
      <button class="outline" (click)="CloseDialog()" *ngIf="Parentdata.DisplayCancel">{{"Cancel" |
        translate}}</button>
      <button class="primary-btn ms-2 px-2" (click)="OK()">{{"Ok" | translate}}</button>
  </div>